(function(){
  var _products = {};
  if(!window.SwymCallbacks){window.SwymCallbacks = [];}
  window.SwymCallbacks.push(function(){
    _swat.fetchWrtEventType(function(products){
      // render products - array of objects with same structure as productData
      // {{Insert your rendering function}}
      renderProducts(products);
      // products count - products.length
      // {{Insert your count update}}
      var countHTMLElem = document.getElementById("wishlist-count-span");
      _swat.renderWishlistCount(countHTMLElem, function(cnt, elem){
        // successful rendering
        console.log("Wishlist count", cnt);
      });

    }, _swat.retailerSettings.RelayUI.Title);});


  function renderProducts(products){
    // Handle zero products
    if(products.length == 0){
      $("#wishlist-count").hide();
      $("#zero-wishlist").show();
    }else{
      $("#wishlist-count").show();
      $("#zero-wishlist").hide();
    }
    var productsHtml = products.map(function(product){
      // store local reference
      _products[product.epi] = product;
      return renderProduct(product);
    });
    $("#wishlist-product-list").html(productsHtml);
    $("#wishlist-product-list .custom-wishlist-delete").click(function(e){
      e.preventDefault();
      var productEventId = $(this).data()["productEventid"];
      _swat.deleteEvent(function callback() {
        // Successfully deleted, re-render page
        $(e.currentTarget).closest(".grid-item").remove();
      }, productEventId);
    });
    $("#wishlist-product-list .custom-wishlist-add-to-cart").click(function(e){
      e.preventDefault();
      var productId = $(this).data()["productId"];
      var productData = _products[productId];
      _swat.replayAddToCart(productData, productData.epi, function() {
        // Successfully added, open cart
        _swat.openCartPage();
      });

    });
  }

  function renderProduct(product){
    // Using Mustache with different tags
    Mustache.tags = ["<%","%>"];
    var tmpl = loadTemplate("product-item-tmpl");
    var r = Mustache.render(tmpl, transformProduct(product));
    Mustache.tags = ["{{","}}"];
    return r;
  }
  function transformProduct(product){
    // To use Shopify's default formatter - 
    // But warning - Some themes throw an unknown format exception, 
    // build custom formatter in that case
    // if(Shopify.formatMoney && Shopify.money_format){
    //   product["pr"] = Shopify.formatMoney(product["pr"].toFixed(2));
    //    if(product["op"]){
    //      product["op"] = Shopify.formatMoney(product["op"].toFixed(2));
    //    }
    // }
    product["pr"] = product["pr"].toFixed(2);
    if(product["op"]){
      product["op"] = product["op"].toFixed(2);
    }
    product.currency = _swat.currency; // use currency in case you want to render in the template
    return product;
  }

  function loadTemplate(templateId) {

    var template =  document.getElementById(templateId);
    if(!template) {
      SwymUtils.warn('Error cannot find the template #' + templateId);
      return false;
    }

    var templateHtml = template.innerHTML.trim();
    Mustache.parse(templateHtml);
    return templateHtml;
  }
})();
